import { createContext, ReactNode, useContext, useEffect, useState } from 'react';
import { UserView } from "./api.types";
import { useHttp } from "./Context";
import { logout } from "./fetch";

export const CurrentUserContext = createContext<{ currentUser: UserView | undefined | null, reloadUser: () => void, logoutUser: () => void }>({ currentUser: undefined } as any)
export const useCurrentUser = () => useContext(CurrentUserContext)

export function UserContext(props: { children: ReactNode }) {
    const [currentUser, setCurrentUser] = useState<UserView | undefined | null>(undefined);

    const httpFetch = useHttp()
    const loadUser = () => {
        httpFetch("/api/users/me").then((resp) => {
            if (resp.ok) {
                resp.json().then((data) => { setCurrentUser(data as UserView) })
            } else {
                setCurrentUser(null)
            }
        })
    }
    useEffect(loadUser, [setCurrentUser, httpFetch])
    const logoutUser = () => {
        logout().then(() =>{
            setCurrentUser(null)
        })
    }

    return (
        <CurrentUserContext.Provider value={{ currentUser, reloadUser: loadUser, logoutUser }}>
            {props.children}
        </CurrentUserContext.Provider>
    )
}
